import Vuex, { mapGetters, StoreOptions, Getter, GetterTree, Store, Module } from 'vuex';
import { ConfigState } from './types';
import { StoreState } from '@/types';

const getters: GetterTree<ConfigState, StoreState> = {

};

export default getters;
